import ready from './lib/ready';
import debounce from 'lodash/debounce';

export default class Sticky {
  constructor(headerProduct, headerSticky, options) {
    let desktopWidth = 1024;

    this.headerProduct = headerProduct;
    this.element = headerSticky;
    this.options = options;

    this.refElem = document.querySelector(this.options.refElem);

    this.clone = document.createElement('div');
    if (window.innerWidth < desktopWidth) {
      const headerProductH = this.headerProduct.offsetHeight;
      this.clone.style.height = `${headerProductH}px`;
      this.clone.classList.add('sticky-clone');
    }

    window.addEventListener('scroll', debounce(this.check, 100))

    this.check();
  }

  check = () => {
    // If refElement is not visible and elemTop is at top of window
    // Add sticky class
    if (this.element.getBoundingClientRect().top <= 0) {
      if (this.isInViewport(this.refElem) || this.isInViewport(this.headerProduct)) {
        if (this.isSticky()) {
          this.unstick();
        }

      } else {
        if (!this.isSticky()) {
          this.stick()
        }
      }
    }

    if (this.isSticky()) {
      if (this.clone && this.clone.getBoundingClientRect().top > 0) {
        this.unstick()
      }
    }
  }

  unstick = () => {
    if (this.isSticky()) {
      this.element.classList.remove('is-sticky');

      let stickyClone = document.querySelector('.sticky-clone');
      if (stickyClone !== null) {
        stickyClone.remove();
      }
    }
  }

  stick = () => {
    this.headerProduct.parentNode.prepend(this.clone);
    this.element.classList.add('is-sticky');
  }

  isSticky = () => {
    return this.element.classList.contains('is-sticky');
  }

  isInViewport = (elem) => {

    const elemRect = elem.getBoundingClientRect()
    const elemTop = elemRect.top;
    const elemBot = elemRect.top + elemRect.height
    const winTop = window.scrollY
    const winBot = window.scrollY + window.innerHeight
    return (
      !(
        elemBot < 0 || elem.offsetTop > winBot
      )
    );
  };
}

// Sticky header product price mobile
const headerProduct = document.querySelector('.crtProductHeader')

ready(() => {
  [].forEach.call(
    document.querySelectorAll('[data-js-sticky]'),
    function (headerSticky) {
      if (document.querySelector('#engine')) {
        new Sticky(headerProduct, headerSticky, {
          refElem: '#engine'
        });
      }
    }
  );
})
